module.exports = __webpack_public_path__ + "static/media/me.60be9ea0.png";